import React from 'react'

const HorizontalLineComponent = () => <div className="ui divider" />

export default HorizontalLineComponent
